<template>
    <div class="flex justify-center">
        <div class="">
            <div>
                <span class="relative z-0 inline-flex shadow-sm">
                    <a @click="update(prev)"
                       class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150">
                      <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                              clip-rule="evenodd"/>
                      </svg>
                    </a>
                    <button v-html="formated" type="button"
                            class="font-bold -ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                    ></button>
                    <a @click="update(next)"
                       class="-ml-px relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-500 transition ease-in-out duration-150">
                      <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd"
                              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                              clip-rule="evenodd"/>
                      </svg>
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "Monthspicker",

    props: ['date'],

    computed: {
        moment() {
            return moment(this.date);
        },
        formated() {
            return this.moment.format('MMMM YYYY');
        },
        next() {
            return moment(this.date).add(1, 'months').format('YYYY-MM');
        },
        prev() {
            return moment(this.date).subtract(1, 'months').format('YYYY-MM');
        },
    },

    methods: {
        update(what) {
            this.$emit('date', what);
        },
    },
}
</script>

<style scoped>

</style>
